module.exports = __webpack_public_path__ + "img/eggs__img.742592f0.svg";